export const OPTIMIZED_RESIZE = 'optimizedResize';
export default (function () {
	const throttle = function (type, name, obj) {
		obj = obj || window;
		let running = false;
		const func = function () {
			if (running) {
				return;
			}
			running = true;
			requestAnimationFrame(() => {
				obj.dispatchEvent(new CustomEvent(name));
				running = false;
			});
		};
		obj.addEventListener(type, func);
	};

	throttle('resize', 'optimizedResize');
})();



// WEBPACK FOOTER //
// ./src/utils/optimisedResize.js